module.exports = __webpack_public_path__ + "fonts/Outfit-SemiBold.f4bde763.ttf";